// IocTable.jsx 🧠📡 with Delete + Toast Integration
import React, { useState, useEffect } from "react";
import axios from "axios";
import IocRow from "./IocRow";
import IocFilters from "./IocFilters";
import IocPagination from "./IocPagination";
import AddIocModal from "./AddIocModal";
import { Toast, ToastContainer } from "react-bootstrap";

const IocTable = ({ userCountryCode }) => {
  const [iocs, setIocs] = useState([]);
  const [expanded, setExpanded] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [filters, setFilters] = useState({
    iocType: "",
    status: "",
    criticality: "",
    affected_country: "",
    time_range: "",
    related_to_incident: false,
  });
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [modalVisible, setModalVisible] = useState(false);
  
  const [totalFiltered, setTotalFiltered] = useState(0);
  const [totalAll, setTotalAll] = useState(0);

  const [toast, setToast] = useState({ show: false, message: "", variant: "success" });
  
  const handleEditSuccess = (message = "IoC updated successfully!") => {
	  fetchData();
	  showToast(message, "success");
  };

  const showToast = (message, variant = "success") => {
    setToast({ show: true, message, variant });
    setTimeout(() => setToast({ ...toast, show: false }), 3000);
  };

  const fetchData = async () => {
    const params = {
      page,
      searchQuery,
      ...filters,
      related_to_incident: filters.related_to_incident ? 1 : undefined,
    };
    try {
      const res = await axios.get("/api/iocs.php", { params });
      setIocs(res.data.iocs);
      setTotalPages(res.data.total_pages);
      setTotalFiltered(res.data.total_filtered || 0);
      setTotalAll(res.data.total_all || 0);
      setExpanded({});
    } catch (err) {
      console.error("Erreur de chargement :", err);
      showToast("Failed to load IoCs", "danger");
    }
  };
  
  const [userTags, setUserTags] = useState([]);

	useEffect(() => {
	  fetch("/api/get_user_tags.php")
		.then(res => res.json())
		.then(data => {
		  if (data.tags) setUserTags(data.tags);
		});
	}, []);

  useEffect(() => {
    fetchData();
  }, [searchQuery, filters, page]);

  const toggleCollapse = (id) => {
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFilters({
      ...filters,
      [name]: type === "checkbox" ? checked : value,
    });
    setPage(1);
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setPage(1);
  };

  const resetFilters = () => {
    setFilters({
      iocType: "",
      status: "",
      criticality: "",
      affected_country: "",
      time_range: "",
      related_to_incident: false,
    });
    setSearchQuery("");
    setPage(1);
  };

  const handleAddSuccess = (message = "IoC added successfully!") => {
    setModalVisible(false);
    setPage(1);
    fetchData();
    showToast(message, "success");
  };

  const handleDelete = async (id) => {
    try {
      const res = await axios.post("/api/delete_ioc.php", { id });
      if (res.data.success) {
        showToast("IoC deleted successfully", "success");
        fetchData();
      } else {
        showToast(res.data.error || "Failed to delete IoC", "danger");
      }
    } catch (err) {
      console.error("Delete error:", err);
      showToast("Server error while deleting", "danger");
    }
  };

  return (
    <div className="ioc-wrapper mx-auto mt-4">
      <IocFilters
        filters={filters}
        handleChange={handleChange}
        resetFilters={resetFilters}
        searchQuery={searchQuery}
        handleSearch={handleSearch}
        handleCollapseReset={() => setExpanded({})}
        onAddIoc={() => setModalVisible(true)}
        totalCount={totalFiltered}
        totalAll={totalAll}
      />

      <table className="table table-dark table-bordered" style={{ border: "1px solid #333" }}>
        <thead>
          <tr>
            <th style={{ color: "#f8f9fa", backgroundColor: "#1e1e1e", maxWidth: "55px", minWidth: "55px" }}>Type</th>
            <th style={{ color: "#f8f9fa", backgroundColor: "#1e1e1e", maxWidth: "300px", minWidth: "300px" }}>IoCs</th>
            <th style={{ color: "#f8f9fa", backgroundColor: "#1e1e1e", maxWidth: "700px", minWidth: "700px" }}>Description</th>
            <th style={{ color: "#f8f9fa", backgroundColor: "#1e1e1e", maxWidth: "90px", minWidth: "90px" }}>Status</th>
            <th style={{ color: "#f8f9fa", backgroundColor: "#1e1e1e", maxWidth: "180px", minWidth: "180px" }}>Date (GMT+1)</th>
          </tr>
        </thead>
        <tbody>
          {iocs.map((ioc) => (
            <IocRow
              key={ioc.id}
              ioc={ioc}
              isExpanded={!!expanded[ioc.id]}
              toggleCollapse={toggleCollapse}
              onDelete={handleDelete}
			  onEditSuccess={handleEditSuccess}
			  userCountryCode={userCountryCode}
			  personalTags={userTags}
            />
          ))}
        </tbody>
      </table>

      <IocPagination
        page={page}
        totalPages={totalPages}
        onPageChange={(newPage) => setPage(newPage)}
      />

      <AddIocModal
        show={modalVisible}
        onHide={() => setModalVisible(false)}
        onSuccess={handleAddSuccess}
      />

      <ToastContainer position="bottom-end" className="p-3">
        <Toast show={toast.show} bg={toast.variant} onClose={() => setToast({ ...toast, show: false })}>
          <Toast.Body className="text-white">{toast.message}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};

export default IocTable;
